/** 搜索相关API **/
import { config } from "@/utils/config";
import { omniAxios } from "@/utils/axios";

// 关键词埋点
export function buriedPointSearchKeyword({ batchNo, dengji, keywords, pageNum, searchType, sortBy, userId }) {
  return omniAxios({
    url: config.buriedPointSearchKeywordPath,
    method: "post",
    params: {
      batchNo,
      dengji,
      keywords,
      pageNum,
      searchType,
      sortBy,
      userId,
    },
    isTracker: true, // 埋点类接口
    withCredentials: false,
  });
}

// 获取相关搜索
export function websiteSamejobSearch({ keyword = "" }) {
  return omniAxios({
    url: config.restServicePath + config.apiV1Path + config.websiteSamejobSearchPath,
    method: "get",
    params: {
      keyword,
    },
  });
}

// 获取相关搜索新接口2274
export function websiteKeywordSearchV3({ keyword = "" }) {
  return omniAxios({
    url: config.restServicePath + config.apiV1Path + config.websiteKeywordSearchV3Path,
    method: "get",
    params: {
      keyword,
    },
  });
}

// 获取相关搜索v2
export function websiteSamejobSearchV2({ keyword = "" }) {
  return omniAxios({
    url: config.restServicePath + config.apiV1Path + config.websiteSamejobSearchV2Path,
    method: "get",
    params: {
      keyword,
    },
  });
}

// 获取相关热搜
export function websiteAssociationalSearch({ keyWord = "", fetchCount = 0 }) {
  return omniAxios({
    url: config.restServicePath + config.apiV1Path + config.websiteAssociationalSearchPath,
    method: "get",
    params: {
      keyWord,
      fetchCount,
    },
  });
}

// 获取相关公司
export function websiteSearchSolrCompany({ keyword = "" }) {
  return omniAxios({
    url: config.restServicePath + config.websiteSearchSolrCompanyPath,
    method: "post",
    params: {
      keyword,
      childLimit: 0,
      currentPage: 1,
      numPage: 5,
      onlyName: 1,
    },
  });
}

// 获取搜索列表
export function websiteSearchSolr(params) {
  return omniAxios({
    url: config.restServicePath + config.websiteSearchSolrPath,
    method: "post",
    params,
    cancelLastSameRequest: true,
  });
}

// 搜索有值需记录埋点插入搜索结果日志
export function serviceHitRateInsert(data) {
  return omniAxios({
    url: config.serviceHitRateInsertPath,
    method: "post",
    params: data,
    isFormData: true,
  });
}

// 标准导出
export function searchExportCheck(data) {
  return omniAxios({
    url: config.searchExportCheckPath,
    method: "post",
    params: data,
  });
}

// 定制导出需求
export function exportCustomExport({ userId = "", demand = "", phone = "" }) {
  return omniAxios({
    url: config.exportCustomExportPath,
    method: "post",
    params: {
      userId,
      demand,
      phone,
    },
  });
}

// 获取用户邮箱绑定状态
export function pushPeriodAndAcceptMailBox() {
  return omniAxios({
    url: config.pushPeriodAndAcceptMailBoxPath,
    method: "get",
    params: {},
  });
}

// 批量收藏/取消收藏
export function collectControlleraddUserCollect(params) {
  return omniAxios({
    url: config.collectControlleraddUserCollectPath,
    method: "post",
    params,
    isFormData: true,
  });
}
//相似单位免费试用-搜索

export function restEnterpriseCompetitivenessCheckFreePop(params) {
  return omniAxios({
    url: config.restEnterpriseCompetitivenessCheckFreePopPath,
    method: "get",
    params,
  });
}
//搜索相似单位，企业商情权限（有试用次数）。
export function restEnterpriseCompetitivenessPermissionCheck(params) {
  return omniAxios({
    url: config.restEnterpriseCompetitivenessPermissionCheckPath,
    method: "get",
    params,
  });
}

// 相似供应商/采购商 - 搜索
export function competitivenessSimilarUnit({ keyword = "", areas = "" }) {
  return omniAxios({
    url: config.competitivenessSimilarUnitPath,
    method: "get",
    params: {
      keyword,
      areas,
    },
  });
}
// 相似供应商/采购商 - 搜索-列表
export function competitivenessSimilarUnitList(params) {
  return omniAxios({
    url: config.competitivenessSimilarUnitListPath,
    method: "get",
    params,
  });
}
// 相似供应商/采购商 - 更多联系人-列表contactsUserWebsiteListpath
export function contactsUserList(params) {
  return omniAxios({
    url: config.contactsUserListPath,
    method: "get",
    params,
  });
}
// 搜索公司 - 更多联系人-列表
export function contactsUserWebsiteList(params) {
  return omniAxios({
    url: config.contactsUserWebsiteListPath,
    method: "get",
    params,
  });
}
// 搜索公司更多联系人,判断是否收藏该公司
export function accountCollectCompanyFlag({ companyName = "" }) {
  return omniAxios({
    url: config.accountCollectCompanyFlagPath,
    method: "post",
    params: {
      companyName,
    },
  });
}
// 收藏该公司
export function accountCollectCompanyAdd({ companyName = "" }) {
  return omniAxios({
    url: config.accountCollectCompanyAddPath,
    method: "post",
    params: {
      companyName,
    },
    isFormData: true,
  });
}
// 取消收藏该公司
export function accountCollectCompanyDelete({ companyName = "" }) {
  return omniAxios({
    url: config.accountCollectCompanyDeletePath,
    method: "post",
    params: {
      companyName,
    },
    isFormData: true,
  });
}

// 获取企业信息
export function enterpriseCompanySearch({ keyword = "" }) {
  return omniAxios({
    url: config.enterpriseCompanySearchPath,
    method: "get",
    params: {
      keyword,
    },
  });
}
// 获取行业分类
export function classInfoSearchClassInfo(params) {
  return omniAxios({
    url: config.classInfoSearchClassInfoPath,
    method: "post",
    params,
  });
}
//保存用户反馈行业分类
export function searchFeedbackFourLeve(params) {
  return omniAxios({
    url: config.searchFeedbackFourLevelPath,
    method: "post",
    params,
  });
}
// 获取默认地址
export function restAccountSubscribeGetUserDefaultRegion() {
  return omniAxios({
    url: config.restAccountSubscribeGetUserDefaultRegionPath,
    method: "get",
    params: {},
  });
}

// 通过行业id查询行业关键词列表
export function restAccountGetKeyWordList() {
  return omniAxios({
    url: config.restAccountGetKeyWordListPath,
  });
}

// 右侧免费用户显示的推荐供应商
export function restApplicationAdSupplyList(params) {
  return omniAxios({
    url: config.restApplicationAdSupplyListPath,
    method: "get",
    params,
  });
}

// 搜索关键字取相关关键字公司
export function websiteAdvertisement(params) {
  return omniAxios({
    url: config.websiteAdvertisementPath,
    method: "get",
    params,
  });
}

// 获取企业竞争力分析入口信息
export function competitivenessEntranceInfo(params) {
  return omniAxios({
    url: config.competitivenessEntranceInfoPath,
    method: "get",
    params,
  });
}

// 获取列表排序信息 0 大搜 1 找商机
export function searchLogQuerySearchSortType({ source = 0 }) {
  return omniAxios({
    url: config.searchLogQuerySearchSortTypePath,
    method: "get",
    params: {
      source,
    },
  });
}
